import { render, staticRenderFns } from "./AppFormItem.vue?vue&type=template&id=5eabf22e&"
import script from "./AppFormItem.vue?vue&type=script&lang=ts&"
export * from "./AppFormItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppFormItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports